﻿import './jquery-init';
import 'jquery-validation/dist/jquery.validate';
import 'jquery-timepicker/jquery.timepicker'
import AutoNumeric from 'autonumeric/dist/autoNumeric'
window.AutoNumeric = AutoNumeric;
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range.js';
window.moment = moment;
import * as Popper from "@popperjs/core"
window.Popper = Popper;
import 'bootstrap-table';
import 'externalpackages/jquery-ui-1.12.1/jquery-ui';
import Mustache from 'mustache';
window.Mustache = Mustache;
import 'easy-autocomplete';
import he from 'he';
window.he = he;